import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { TestimonialsFirstSet, TestimonialsSecondSet } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ProductOverview } from './components/ProductOverview';
import { TomosCarousel } from './components/TomosCarousel';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { ComplexCases } from './components/ComplexCases';
import { CostComparison } from './components/CostComparison';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1442042037589312');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // Noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1442042037589312&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.head.appendChild(noscript);
    return () => {
      document.head.removeChild(script);
      document.head.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen bg-dark-900 text-cream font-sans selection:bg-primary/30 selection:text-cream" data-id="element-0">
      <Hero data-id="element-1" />
      <StatsBar data-id="element-2" />
      <TomosCarousel data-id="element-3" />
      <TestimonialsFirstSet data-id="element-4" />
      <PainPoints data-id="element-5" />
      <ProductOverview data-id="element-6" />
      <Bonuses data-id="element-7" />
      <Pricing data-id="element-8" />
      <ComplexCases data-id="element-9" />
      <TestimonialsSecondSet data-id="element-10" />
      <CostComparison data-id="element-11" />
      <Guarantee data-id="element-12" />
      <FAQ data-id="element-13" />
      {/* Final CTA is just a reuse of the Pricing section */}
      <div className="border-t-4 border-primary/20" data-id="element-14">
        <Pricing data-id="element-15" />
      </div>
      <Footer data-id="element-16" />
    </div>;
}